import { useState, useEffect } from 'react';
import axios from '../config/axios';
import { getApiUrl } from '../config/environment';

// Cache local: o toggle muda raramente e várias telas consultam (catálogo, agenda, perfil).
let cachedEnabled: boolean | undefined;
let cachePromise: Promise<boolean> | null = null;

async function fetchPlansEnabled(): Promise<boolean> {
  if (cachedEnabled !== undefined) return cachedEnabled;
  if (!cachePromise) {
    cachePromise = axios
      .get(getApiUrl('/clinic/settings'))
      .then((res) => {
        cachedEnabled = Boolean(res.data?.data?.plans_enabled);
        return cachedEnabled;
      })
      .catch(() => {
        cachedEnabled = false;
        return false;
      });
  }
  return cachePromise;
}

export function invalidatePlansEnabledCache(): void {
  cachedEnabled = undefined;
  cachePromise = null;
}

/** Indica se o módulo de planos/mensalidades está ativo na unidade corrente. */
export function usePlansEnabled(): { plansEnabled: boolean; loading: boolean } {
  const [plansEnabled, setPlansEnabled] = useState<boolean>(cachedEnabled ?? false);
  const [loading, setLoading] = useState(cachedEnabled === undefined);

  useEffect(() => {
    let cancelled = false;

    const load = () => {
      fetchPlansEnabled().then((enabled) => {
        if (cancelled) return;
        setPlansEnabled(enabled);
        setLoading(false);
      });
    };

    load();

    // Cada unidade tem seu próprio toggle.
    const onUnitChanged = () => {
      invalidatePlansEnabledCache();
      setLoading(true);
      load();
    };
    window.addEventListener('unit:changed', onUnitChanged);
    return () => {
      cancelled = true;
      window.removeEventListener('unit:changed', onUnitChanged);
    };
  }, []);

  return { plansEnabled, loading };
}

export default usePlansEnabled;
